import { render, staticRenderFns } from "./BusinessDetails.vue?vue&type=template&id=3fafdaa6&scoped=true"
import script from "./BusinessDetails.vue?vue&type=script&lang=js"
export * from "./BusinessDetails.vue?vue&type=script&lang=js"
import style0 from "./BusinessDetails.vue?vue&type=style&index=0&id=3fafdaa6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fafdaa6",
  null
  
)

export default component.exports